import {csvParse} from "d3-dsv";
import dsv from "./dsv";

export default dsv("text/csv", csvParse);



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-request/src/csv.js
// module id = 405
// module chunks = 0